import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Presupuesto`

export function buscarTodos(idUsuario) {
  return http.get(`${API_ENDPOINT}/BuscarTodos/${idUsuario}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener los presupuestos.',
      tipoError: 'presupuestos'
    }
  })
}

export function buscarPorVendedor(idUsuario, buscar) {
  return http.get(`${API_ENDPOINT}/BuscarPorVendedor/${idUsuario}/${buscar}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener los presupuestos.',
      tipoError: 'presupuestos'
    }
  })
}

export function buscarPorComprador(idUsuario, buscar) {
  return http.get(`${API_ENDPOINT}/BuscarPorComprador/${idUsuario}/${buscar}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener los presupuestos.',
      tipoError: 'presupuestos'
    }
  })
}

export function buscarPorId(idPresupuesto) {
  return http.get(`${API_ENDPOINT}/BuscarPorId/${idPresupuesto}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener el presupuesto.',
      tipoError: 'presupuestos',
      devolverNull: true
    }
  })
}

export function insertar(presupuesto) {
  return http.post(`${API_ENDPOINT}/insertar/`, presupuesto)
}
export function actualizar(presupuesto) {
  return http.put(API_ENDPOINT, presupuesto)
}

export function comprar(presupuesto) {
  return http.post(`${API_ENDPOINT}/comprar/`, presupuesto)
}

export function eliminar(idPresupuesto) {
  return http.delete(API_ENDPOINT, idPresupuesto)
}

export function buscarPorEmpresa(empid, esVendedor) {
  return http.get(`${API_ENDPOINT}/BuscarPorEmpresa/${empid}/${esVendedor}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener los presupuestos.',
      tipoError: 'presupuestos'
    }
  })
}
